const UserAddEdit = () => import("./views/UserAddEdit.vue");
const Users = () => import("./views/Users.vue");

export const userAdminRoutes = [
  {
    path: "/admin/user/edit/:id?",
    name: "AdminUserAddEdit",
    component: UserAddEdit,
    props: true,
  },
  {
    path: "/admin/user",
    name: "AdminUsers",
    component: Users,
  },
];
